import React from 'react';
import Div from '../Div';
import './spacing.scss';

export default function Spacing({ lg, md }) {
  return <Div className={`_height_${lg} _height_lg_${md}`}></Div>;
}
